import {
  useEnvironmentsForAdrIncident,
  useRulesForAdrIncident
} from "@/pages/TriagePage/application/useAdrIncidents"
import { RuleCard } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/molecules/RuleCard"

import styles from "./DetailsSection.module.scss"

import type { RuleListProps } from "./DetailsSection.types"

export const RuleList = (props: RuleListProps) => {
  const { config } = props
  const environmentsContext = useEnvironmentsForAdrIncident(config)
  const disabled = environmentsContext.response?.allDisabled || false
  const rulesContext = useRulesForAdrIncident(config)
  const { list: detectionTypes = [], data = {} } =
    rulesContext.response?.data || {}

  return (
    <div className={styles.wrapper}>
      {detectionTypes.map(({ label, value, type }, index) => (
        <RuleCard
          key={index}
          name={label}
          data={data[value]}
          type={type}
          disabled={disabled}
        />
      ))}
    </div>
  )
}
